const ASYNC_LAUNCH_MARKER = 'Async agent launched successfully.';
const INTERNAL_TRAILER_MARKERS = [
  'You will be notified automatically when it completes.',
  "you'll get a completion notification.",
] as const;

/** Removes ACP adapter coordination metadata that must never reach the chat UI. */
export function sanitizeSubagentTranscript(text: string): string {
  const trimmed = text.trim();
  if (!trimmed.startsWith(ASYNC_LAUNCH_MARKER)) return trimmed;

  let boundary = -1;
  for (const marker of INTERNAL_TRAILER_MARKERS) {
    const index = trimmed.lastIndexOf(marker);
    if (index !== -1) boundary = Math.max(boundary, index + marker.length);
  }

  // Prefer hiding the whole payload over leaking IDs, paths, or internal instructions.
  return boundary === -1 ? '' : trimmed.slice(boundary).trim();
}
